export interface LegacyTheme {
  typography: {
    fontFamily: {
      primary: ThemeValue;
      secondary: ThemeValue;
      serif: ThemeValue;
      monospaced: ThemeValue;
    };
    weight: {
      normal: ThemeValue;
      semi: ThemeValue;
      bold: ThemeValue;
    };
    size: {
      h1: ThemeValue;
      h2: ThemeValue;
      h3: ThemeValue;
      h4: ThemeValue;
      body: ThemeValue;
      copy: ThemeValue;
      paragraph: ThemeValue;
      small: ThemeValue;
      tiny: ThemeValue;
      button: ThemeValue;
      xlarge: ThemeValue;
    };
  };
  colors: {
    twitter: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    facebook: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    google: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    linkedin: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    youtube: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    instagram: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    flickr: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    tumblr: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    pinterest: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    body: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    active: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    altActive: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    mute: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    accent: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    alt: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    contrast: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    gradient: {
      primary: {
        copy: ThemeValue;
        fill: ThemeValue;
        keyline: ThemeValue;
      };
    };
    shadow: {
      box_shadow_100: ThemeValue;
      box_shadow_200: ThemeValue;
      box_shadow_300: ThemeValue;
      box_shadow_400: ThemeValue;
      box_shadow_500: ThemeValue;
    };
    info: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    timestamp: ThemeValue;
    anchor: ThemeValue;
    overlay: {
      alt: {
        copy: ThemeValue;
        fill: ThemeValue;
        keyline: ThemeValue;
      };
      altActive: {
        copy: ThemeValue;
        fill: ThemeValue;
        keyline: ThemeValue;
      };
      active: {
        copy: ThemeValue;
        fill: ThemeValue;
        keyline: ThemeValue;
      };
      mute: {
        copy: ThemeValue;
        fill: ThemeValue;
        keyline: ThemeValue;
      };
      accent: {
        copy: ThemeValue;
        fill: ThemeValue;
        keyline: ThemeValue;
      };
      altAccent: {
        copy: ThemeValue;
        fill: ThemeValue;
        keyline: ThemeValue;
      };
      contrast: {
        copy: ThemeValue;
        fill: ThemeValue;
        keyline: ThemeValue;
      };
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    input: {
      active: {
        copy: ThemeValue;
        fill: ThemeValue;
        keyline: ThemeValue;
      };
      error: {
        copy: ThemeValue;
        fill: ThemeValue;
        keyline: ThemeValue;
      };
      checkbox: {
        copy: ThemeValue;
        fill: ThemeValue;
        keyline: ThemeValue;
      };
      text: {
        copy: ThemeValue;
        fill: ThemeValue;
        keyline: ThemeValue;
      };
      copy: ThemeValue;
    };
    error: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    warning: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    success: {
      copy: ThemeValue;
      fill: ThemeValue;
      keyline: ThemeValue;
    };
    button: {
      primary: {
        hover: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        focus: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        active: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        disabled: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        copy: ThemeValue;
        fill: ThemeValue;
        keyline: ThemeValue;
      };
      secondary: {
        hover: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        focus: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        active: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        disabled: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        copy: ThemeValue;
        fill: ThemeValue;
        keyline: ThemeValue;
      };
      cta: {
        hover: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        focus: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        active: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        disabled: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        copy: ThemeValue;
        fill: ThemeValue;
        keyline: ThemeValue;
      };
      icon: {
        hover: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        focus: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        active: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        disabled: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        copy: ThemeValue;
        fill: ThemeValue;
        keyline: ThemeValue;
      };
      standard: {
        hover: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        focus: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        active: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        disabled: {
          copy: ThemeValue;
          fill: ThemeValue;
          keyline: ThemeValue;
        };
        copy: ThemeValue;
        fill: ThemeValue;
        keyline: ThemeValue;
      };
      copy: ThemeValue;
    };
    contrastHeader: {
      keyline: ThemeValue;
    };
  };
}

export interface Typography {
  borderFocusWidth: ThemeValue;
  size: {
    title: ThemeValue;
    h1: ThemeValue;
    h2: ThemeValue;
    body: ThemeValue;
    small: ThemeValue;
  };
  fontFamily: {
    primary: ThemeValue;
  };
  fontWeight: {
    normal: ThemeValue;
    bold: ThemeValue;
    black: ThemeValue;
  };
  pageTitle: {
    size: ThemeValue;
    weight: ThemeValue;
    altWeight: ThemeValue;
    lineHeight: ThemeValue;
    mobileSize: ThemeValue;
    mobileLineHeight: ThemeValue;
  };
  sectionTitle: {
    size: ThemeValue;
    weight: ThemeValue;
    altWeight: ThemeValue;
    lineHeight: ThemeValue;
    mobileSize: ThemeValue;
    mobileLineHeight: ThemeValue;
  };
  subSectionTitle: {
    size: ThemeValue;
    weight: ThemeValue;
    subTitleWeight: ThemeValue;
    lineHeight: ThemeValue;
    mobileSize: ThemeValue;
    mobileLineHeight: ThemeValue;
  };
  body: {
    size: ThemeValue;
    weight: ThemeValue;
    lineHeight: ThemeValue;
    style: ThemeValue;
  };
  bodyPlaceHolder: {
    size: ThemeValue;
    lineHeight: ThemeValue;
    style: ThemeValue;
  };
  hyperlink: {
    size: ThemeValue;
    weight: ThemeValue;
    lineHeight: ThemeValue;
  };
  label: {
    size: ThemeValue;
    weight: ThemeValue;
    lineHeight: ThemeValue;
  };
  metadata: {
    size: ThemeValue;
    weight: ThemeValue;
    lineHeight: ThemeValue;
    textTransform: ThemeValue;
  };
  timestamp: {
    size: ThemeValue;
    lineHeight: ThemeValue;
  };
  small: {
    size: ThemeValue;
    lineHeight: ThemeValue;
  };
}

export interface Colors {
  focusBorder: ThemeValue;
  focusBorderAlt?: ThemeValue;
  focusBorderAltInverse?: ThemeValue;
  errorBorder: ThemeValue;
  button: {
    text: ThemeValue;
    background: ThemeValue;
    disabledText: ThemeValue;
    disabledBackground: ThemeValue;
    activeBackground: ThemeValue;
    focusBackground: ThemeValue;
    hoverBackground: ThemeValue;
    lightBackground: ThemeValue;
    disabledLightBackground: ThemeValue;
    activeLightBackground: ThemeValue;
    focusLightBackground: ThemeValue;
    hoverLightBackground: ThemeValue;
    secondary: {
      text: ThemeValue;
      background: ThemeValue;
      border: ThemeValue;
      hoverText: ThemeValue;
      hoverBackground: ThemeValue;
      hoverBorder: ThemeValue;
      activeText: ThemeValue;
      activeBackground: ThemeValue;
      focusBackground: ThemeValue;
      disabledBorder: ThemeValue;
      disabledBackground: ThemeValue;
    };
    outlined: {
      text: ThemeValue;
      background: ThemeValue;
      border: ThemeValue;
      hoverText: ThemeValue;
      hoverBackground: ThemeValue;
      hoverBorder: ThemeValue;
      disabledBackground: ThemeValue;
      activeBackground: ThemeValue;
      focusBackground: ThemeValue;
      disabledText: ThemeValue;
      disabledBorder: ThemeValue;
    };

    onlyText: {
      text: ThemeValue;
      hoverText: ThemeValue;
      background: ThemeValue;
      disabledBackground: ThemeValue;
      hoverBackground: ThemeValue;
      activeBackground: ThemeValue;
      focusBackground: ThemeValue;
      disabledText: ThemeValue;
    };

    cta: {
      background: ThemeValue;
      disabledBackground: ThemeValue;
      activeBackground: ThemeValue;
      focusBackground: ThemeValue;
      hoverBackground: ThemeValue;
    };
  };
  icon: {
    success: ThemeValue;
    error: ThemeValue;
  };
  input: {
    text: ThemeValue;
    background: ThemeValue;
    border: ThemeValue;
    disabledText: ThemeValue;
    disabledBackground: ThemeValue;
    disabledBorder: ThemeValue;
    errorBackground: ThemeValue;
    placeholderText: ThemeValue;
  };
  portfolioNav: {
    background: ThemeValue;
  };
  masthead: {
    background: ThemeValue;
  };
  modal: {
    background: ThemeValue;
    footerBackground: ThemeValue;
  };
  popover: {
    background: ThemeValue;
    border: ThemeValue;
    success: ThemeValue;
    error: ThemeValue;
  };
  overlay: {
    background: ThemeValue;
  };
  toast: {
    error: {
      background: ThemeValue;
      iconBackground: ThemeValue;
      icon: ThemeValue;
    };
    warning: {
      background: ThemeValue;
      iconBackground: ThemeValue;
      icon: ThemeValue;
    };
    success: {
      background: ThemeValue;
      iconBackground: ThemeValue;
      icon: ThemeValue;
    };
    info: {
      background: ThemeValue;
      iconBackground: ThemeValue;
      icon: ThemeValue;
    };
  };
  dropdownMenu: {
    border: ThemeValue;
    background: ThemeValue;
  };
  menuItem: {
    text: ThemeValue;
    disabledText: ThemeValue;
    activeBackground: ThemeValue;
    hoverBackground: ThemeValue;
    focusBackground: ThemeValue;
  };
  tooltip: {
    text: ThemeValue;
    background: ThemeValue;
  };
  ribbon: {
    background: ThemeValue;
  };
  hyperlink: {
    color: ThemeValue;
    hoverColor: ThemeValue;
    alt: {
      color: ThemeValue;
      hoverColor: ThemeValue;
    };
  };
  tab: {
    selectedBorder: ThemeValue;
    hoverBorder: ThemeValue;
  };
  checkbox: {
    text: ThemeValue;
    border: ThemeValue;
    background: ThemeValue;
    tick: ThemeValue;
    disabledBorder: ThemeValue;
    disabledText: ThemeValue;
    disabledBackground: ThemeValue;
    disabledTick: ThemeValue;
  };
  radioButton: {
    text: ThemeValue;
    border: ThemeValue;
    background: ThemeValue;
    tick: ThemeValue;
    disabledBorder: ThemeValue;
    disabledText: ThemeValue;
    disabledBackground: ThemeValue;
    disabledTick: ThemeValue;
  };
  toggleSwitch: {
    onBackground: ThemeValue;
    offBackground: ThemeValue;
  };
  tag: {
    text: ThemeValue;
    background: ThemeValue;
    disabledText: ThemeValue;
    disabledBackground: ThemeValue;
    activeBackground: ThemeValue;
    focusBackground: ThemeValue;
    hoverBackground: ThemeValue;
  };
  card: {
    background: ThemeValue;
    selectedBackground: ThemeValue;
  };
  steppedProgressBar: {
    background: ThemeValue;
    foreground: ThemeValue;
  };
  genericBox: {
    background: ThemeValue;
  };
  socialMedia: {
    twitter: ThemeValue;
    facebook: ThemeValue;
    google: ThemeValue;
    linkedin: ThemeValue;
    youtube: ThemeValue;
    instagram: ThemeValue;
    flickr: ThemeValue;
    tumblr: ThemeValue;
    pinterest: ThemeValue;
    tiktok: ThemeValue;
  };
  text: {
    success: ThemeValue;
    error: ThemeValue;
  };
  banner: {
    success: {
      background: ThemeValue;
    };
  };
  primary: ThemeValue;
  primary80: ThemeValue;
  primary60: ThemeValue;
  primary40: ThemeValue;
  primary30: ThemeValue;
  primary20: ThemeValue;
  primary10: ThemeValue;
  accent: ThemeValue;
  accent80: ThemeValue;
  accent60: ThemeValue;
  accent40: ThemeValue;
  accent20: ThemeValue;
  accent10: ThemeValue;
  secondary: ThemeValue;
  secondary80: ThemeValue;
  secondary60: ThemeValue;
  secondary40: ThemeValue;
  secondary20: ThemeValue;
  secondary10: ThemeValue;
  complementaryYellow: ThemeValue;
  complementaryOrange: ThemeValue;
  complementaryOrange80: ThemeValue;
  complementaryOrange60: ThemeValue;
  complementaryOrange40: ThemeValue;
  complementaryOrange20: ThemeValue;
  complementaryOrange10: ThemeValue;
  complementaryGreen: ThemeValue;
  complementaryGreen80: ThemeValue;
  complementaryGreen60: ThemeValue;
  complementaryGreen40: ThemeValue;
  complementaryGreen20: ThemeValue;
  complementaryGreen10: ThemeValue;
  complementaryPurple: ThemeValue;
  complementaryPurple80: ThemeValue;
  complementaryPurple60: ThemeValue;
  complementaryPurple40: ThemeValue;
  complementaryPurple20: ThemeValue;
  complementaryPurple10: ThemeValue;
  complementaryRed: ThemeValue;
  complementaryRed80: ThemeValue;
  complementaryRed60: ThemeValue;
  complementaryRed40: ThemeValue;
  complementaryRed20: ThemeValue;
  complementaryRed10: ThemeValue;
  darkGrey: ThemeValue;
  darkGrey80: ThemeValue;
  darkGrey60: ThemeValue;
  darkGrey40: ThemeValue;
  darkGrey20: ThemeValue;
  darkGrey10: ThemeValue;
  grey20: ThemeValue;
  lightGrey: ThemeValue;
  lightGrey80: ThemeValue;
  lightGrey60: ThemeValue;
  lightGrey40: ThemeValue;
  lightGrey20: ThemeValue;
  lightGrey10: ThemeValue;
  white: ThemeValue;
  jade?: ThemeValue;
  lake?: ThemeValue;
  mint?: ThemeValue;
  nocturn?: ThemeValue;
  saffron?: ThemeValue;
  spring?: ThemeValue;
  spruce?: ThemeValue;
  tea?: ThemeValue;
}

export interface Spacing {
  focusBorder: ThemeValue;
  input: {
    height: ThemeValue;
  };
  button: {
    height: ThemeValue;
  };
  checkbox: {
    height: ThemeValue;
  };
  radioButton: {
    height: ThemeValue;
  };
  spacing4: ThemeValue;
  spacing8: ThemeValue;
  spacing12: ThemeValue;
  spacing16: ThemeValue;
  spacing20: ThemeValue;
  spacing24: ThemeValue;
  spacing28: ThemeValue;
  spacing32: ThemeValue;
  spacing36: ThemeValue;
  spacing40: ThemeValue;
  spacing44: ThemeValue;
  spacing48: ThemeValue;
  spacing52: ThemeValue;
  spacing56: ThemeValue;
  spacing60: ThemeValue;
  spacing72: ThemeValue;
}

export interface Animation {
  duration: {
    short: ThemeValue;
    shortSlow: ThemeValue;
    standardQuick: ThemeValue;
    standard: ThemeValue;
    long: ThemeValue;
    longSlow: ThemeValue;
  };
  timingFunction: {
    basicEnter: ThemeValue;
    basicExitSmall: ThemeValue;
    basicExitMedium: ThemeValue;
    persistentSmall: ThemeValue;
    persistentMedium: ThemeValue;
    paneExit: ThemeValue;
    modalSmall: ThemeValue;
    overspillSmall: ThemeValue;
    overspillMedium: ThemeValue;
    overspillLarge: ThemeValue;
  };
}

export interface Theme {
  name: string;
  readonly legacy: LegacyTheme;
  typography: Typography;
  colors: Colors;
  spacing: Spacing;
  animation: Animation;
}

export enum AvailableThemes {
  BRAND2020 = 'brand2020',
  BRAND2022 = 'brand2022',
}

export type ThemeValue = string;

export type ThemeValueGetter = (t: Theme) => ThemeValue;

type Unsubscribe = () => void;

export interface ThemeProvider {
  getThemeValue(
    getter: ThemeValueGetter,
    customThemeName?: AvailableThemes,
  ): ThemeValue;
  getIsBrand2020Active: () => boolean;
  subscribe: (listener: () => void) => Unsubscribe;
}
